import { useEffect, useState } from 'react';

import getRichText, {
  type HygraphRichTextContent,
} from 'src/modules/ApiClient/cms/queries/getRichText';

import { useConfig } from './context';

export const useHygraphRichText = (richTextSlug: string) => {
  const [state, setState] = useState<HygraphRichTextContent>();
  const { locale } = useConfig();

  useEffect(() => {
    const fetchGql = async () => {
      const hygraphData = await getRichText(richTextSlug, locale);
      setState(hygraphData);
    };
    fetchGql().catch((_err) => {});
  }, [locale, richTextSlug]);

  return state;
};
